import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncDebugUser({ ...rest }) {
  const AsyncLoad = loadable(() => import("../admin/debugUser"));
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncDebugUser;
